import React from "react";
import { bool } from "prop-types";
import { motion } from "framer-motion";

import BaseIcon from "../BaseIcon";

import theme from "styles/theme";

const RadioIcon = props => {
  const primaryColor = theme.colors.primaryOrange;

  return (
    <BaseIcon fill="none" viewBox="0 0 33 33" {...props}>
      <path
        d="M32 16.5C32 25.0604 25.0604 32 16.5 32C7.93959 32 1 25.0604 1 16.5C1 7.93959 7.93959 1 16.5 1C25.0604 1 32 7.93959 32 16.5Z"
        stroke="currentColor"
        strokeWidth="1"
      />
      <motion.path
        d="M28 16.5C28 22.8513 22.8513 28 16.5 28C10.1487 28 5 22.8513 5 16.5C5 10.1487 10.1487 5 16.5 5C22.8513 5 28 10.1487 28 16.5Z"
        fill={primaryColor}
        stroke={primaryColor}
        strokeWidth="2"
        variants={{
          circleIn: { pathLength: 1, transition: { duration: 0.3 } },

          circleOut: {
            pathLength: 0,
            transition: { duration: 0.2, delay: 0.2 },
          },

          fillIn: {
            fill: primaryColor,
            transition: { duration: 0.2, delay: 0.3 },
          },

          fillOut: { fill: theme.colors.white, transition: { duration: 0.2 } },

          shrink: {
            scale: 0.7,
            originX: "50%",
            originY: "50%",
            transition: { duration: 0.2, delay: 0.4 },
          },

          expand: { scale: 1, originX: "50%", originY: "50%" },
        }}
        animate={
          props.checked
            ? ["circleIn", "fillIn", "shrink"]
            : ["expand", "fillOut", "circleOut"]
        }
        initial={{
          fill: props.checked ? primaryColor : theme.colors.white,
          pathLength: props.checked ? 1 : 0,
          scale: 1,
          originX: "50%",
          originY: "50%",
        }}
      />
    </BaseIcon>
  );
};
export default RadioIcon;

RadioIcon.propTypes = {
  checked: bool,
};
